import { OnInit, Component } from '@angular/core';
import {UserService} from "../../core/user/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SatisfactionService} from "../../core/services/satisfaction.service";
import {take, filter} from 'rxjs/operators';
import {SsoInterceptor} from "../../core/_helpers/sso.interceptor";

@Component({
  selector: 'app-satisfaction',
  templateUrl: './satisfaction.component.html',
  styleUrls: ['./satisfaction.component.scss']
})
export class SatisfactionComponent implements OnInit {
  token!: string;
  idclient!: string;
  idbien!: string;
  email!: string;
  formSubmitted = false;
  formSatisfaction!: FormGroup;
  accompagnements = [
    {value: 1, label: 'Très insatisfait'},
    {value: 2, label: 'Insatisfait'},
    {value: 3, label: 'Moyen'},
    {value: 4, label: 'Satisfait'},
    {value: 5, label: 'Très satisfait'}
  ];
  attentes = [
    {value: 'FULL', label: 'Tout à fait'},
    {value: 'PARTIAL', label: 'Partiellement'},
    {value: 'LOW', label: 'Pas vraiment'},
    {value: 'NO', label: 'Pas du tout'}
  ];
  communications = [
    {value: 'YES', label: 'Oui, tout à fait'},
    {value: 'MEDIUM', label: 'Moyennement'},
    {value: 'NO', label: 'Non, pas suffisamment'}
  ];
  recommandations = [
    {value: 'YES_NOW', label: 'Oui, sans hésiter'},
    {value: 'YES_MAYBE', label: 'Oui, probablement'},
    {value: 'NO', label: 'Non'}
  ];

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private satisfactionService: SatisfactionService,
    private ssoService: SsoInterceptor,
  ) {
  }

  ngOnInit() {
        this.hasReplied();
  }
  hasReplied(){
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.idclient = this.route.snapshot.paramMap.get('idclient') || '';
    this.idbien = this.route.snapshot.paramMap.get('idbien') || '';
    this.email = this.decodeBase64Url(this.token);

    this.satisfactionService
      .requestHasReplied(this.idclient, this.idbien, this.email)
      .pipe(take(1))
      .subscribe(response => {
        if (response.data.hasReplied) {
          void this.router.navigate(['/']);
          return;
        }
        this.buildSatisfaction();
      });
  }
  buildSatisfaction() {
    this.formSatisfaction = this.formBuilder.group({
      idclient: [this.idclient],
      idbien: [this.idbien],
      email: [this.email],
      accompagnement: ['', Validators.required],
      attente: ['', Validators.required],
      communication: ['', Validators.required],
      recommandation: ['', Validators.required],
      commentaire: ['']
    })
  }

  onSubmit() {
    if (this.formSatisfaction.valid) {
      this.formSatisfaction.value.accompagnement = this.inverseValeur(this.formSatisfaction.value.accompagnement);
      this.satisfactionService.requestSatisfaction(this.formSatisfaction.value).subscribe();
      this.formSubmitted = true;
      // Rediriger après 5 secondes
      setTimeout(() => {
        void this.router.navigate(['/']);
      }, 5000);
    } else {
      this.formSatisfaction.markAllAsTouched();
    }
  }

  private  inverseValeur( n: number) {
    return 6 - n;
  }

  private decodeBase64Url(token: string): string {
    // Remettre les caractères originaux + padding
    token = token.replace(/-/g, '+').replace(/_/g, '/');
    while (token.length % 4) {
      token += '=';
    }
    return decodeURIComponent(escape(window.atob(token))); // window.atob décode Base64
  }
}
